module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showNeuesVerzeichnis = true) && (_vm.neu = {})
            }
          }
        }, on), [_c('v-icon', [_vm._v("dns")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Neues Laufwerk")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Suchen",
      "single-line": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": "",
      "label": "",
      "color": "green",
      "dark": ""
    }
  }, [_vm._v("BETA")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-2 pr-0 pl-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": _vm.sideHeight
    }
  }, [_c('v-treeview', {
    attrs: {
      "dense": "",
      "items": _vm.items,
      "activatable": "",
      "return-object": "",
      "hoverable": "",
      "active": _vm.tree,
      "item-key": _vm.id
    },
    on: {
      "update:active": function($event) {
        _vm.tree = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "caption"
        }, [_vm._v(_vm._s(item.name))])]
      }
    }, {
      key: "prepend",
      fn: function(ref) {
        var item = ref.item;
        var open = ref.open;

        return [(item.icon === 'folder') ? _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n              " + _vm._s(open ? "mdi-folder-open" : "mdi-folder") + "\n            ")]) : _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n              " + _vm._s(item.icon) + "\n            ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-2 px-2",
    attrs: {
      "cols": _vm.selectFile.id ? 6 : 9
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": _vm.sideHeight
    }
  }, [_vm._v("\n        " + _vm._s(_vm.tree2) + "\n        "), _c('v-card-title', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v(_vm._s(_vm.tree[0].icon))]), _vm._v("\n          " + _vm._s(_vm.tree[0].name) + "\n          "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showNeuerOrdner = true) && (_vm.neu = {})
            }
          }
        }, on), [_c('v-icon', [_vm._v("create_new_folder")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Neuer Ordner")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showUploadFiles = true) && (_vm.neu = {})
            }
          }
        }, on), [_c('v-icon', [_vm._v("cloud_upload")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Dateien hochladen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.downlaodFolder(_vm.tree[0])
            }
          }
        }, on), [_c('v-icon', [_vm._v("cloud_download")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Ordner herunterladen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.selectFile = _vm.tree[0]
            }
          }
        }, on), [_c('v-icon', [_vm._v("info")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Informationen")])])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.tree[0].id) ? _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "calc(100vh - 270px)",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "pl-1"
  }, [_vm._v("Dateiname")]), _vm._v(" "), _c('th', [_vm._v("Geändert am")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getAllChildren(_vm.tree[0].id)), function(item, index) {
    return _c('tr', {
      key: index,
      on: {
        "click": function($event) {
          item.art === 'Datei' ? (_vm.selectFile = item) : ''
        },
        "dblclick": function($event) {
          item.art === 'Ordner' ? (_vm.tree[0] = item) : (_vm.selectFile = item)
        }
      }
    }, [_c('td', {
      staticClass: "pl-4 pr-1",
      attrs: {
        "width": "20px"
      }
    }, [_c('v-icon', {
      staticClass: "mr-2"
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('td', {
      staticClass: "pl-1"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.date(item.zuletztbearbeitet, "DD.MM.YYYYhhmm")) + " Uhr")]), _vm._v(" "), _c('th', {
      staticClass: "px-1",
      attrs: {
        "width": "20px"
      }
    }, [_c('v-menu', {
      attrs: {
        "bottom": "",
        "left": "",
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "icon": ""
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-item', {
      attrs: {
        "link": ""
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', {
      on: {
        "click": function($event) {
          item.art === 'Ordner' ? (_vm.tree[0] = item) : (_vm.selectFile = item)
        }
      }
    }, [_vm._v("Öffnen")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
      attrs: {
        "link": ""
      }
    }, [_c('v-list-item-title', {
      on: {
        "click": function($event) {
          (_vm.showRenameFile = true) && (_vm.selectFile = item)
        }
      }
    }, [_vm._v("Umbenennen")])], 1), _vm._v(" "), _c('v-list-item', {
      attrs: {
        "link": ""
      }
    }, [_c('v-list-item-title', {
      on: {
        "click": function($event) {
          (_vm.showDeleteFile = true) && (_vm.deleteFileData = item)
        }
      }
    }, [_vm._v("Löschen")])], 1)], 1)], 1)], 1)])
  }), 0)]) : _c('v-card-text', [_vm._v(" Bitte wähle ein Verzeichnis aus um die Dateien anzuzeigen. ")])], 1)], 1), _vm._v(" "), (_vm.selectFile.id) ? _c('v-col', {
    staticClass: "pa-2 pl-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pb-1"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.selectFile = {}
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-1 justify-center"
  }, [(_vm.selectFile.type) ? _c('span', [(_vm.selectFile.type.includes('image') && _vm.selectFile.type !== 'image/svg+xml') ? _c('span', [_c('v-img', {
    attrs: {
      "src": _vm.selectFile.url500,
      "max-width": "250px",
      "max-height": "250px",
      "contain": ""
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function() {
        return [_c('v-row', {
          staticClass: "fill-height grey lighten-3 ma-0",
          attrs: {
            "align": "center",
            "justify": "center"
          }
        }, [_c('v-progress-circular', {
          attrs: {
            "indeterminate": "",
            "color": "grey"
          }
        })], 1)]
      },
      proxy: true
    }], null, false, 1280950732)
  })], 1) : _c('span', [_c('v-icon', {
    attrs: {
      "size": "64"
    }
  }, [_vm._v(_vm._s(_vm.selectFile.icon))])], 1)]) : _c('span', [_c('v-icon', {
    attrs: {
      "size": "64"
    }
  }, [_vm._v(_vm._s(_vm.selectFile.icon))])], 1)]), _vm._v(" "), _c('v-card-title', {
    staticClass: "subtitle-2 pt-1"
  }, [_c('v-spacer'), _vm._v("\n          " + _vm._s(_vm.selectFile.name) + "\n          "), _c('v-spacer')], 1), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": ""
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Zuletzt geändert")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                " + _vm._s(_vm.$filters.date(_vm.selectFile.zuletztbearbeitet, "DD.MM.YYYY")) + " "), _c('br'), _vm._v(_vm._s(_vm.$filters.date(_vm.selectFile.zuletztbearbeitet, "hh:mm")) + "\n                Uhr\n              ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Geändert von")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.$filters.user(_vm.selectFile.zuletztbearbeitetvon, _vm.bbrbbr)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Größe")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.formatSize(_vm.selectFile.size)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Downloads")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                " + _vm._s(_vm.selectFile.downloadLog.length)), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showDownloadLog = true
      }
    }
  }, [_c('v-icon', [_vm._v("info")])], 1)], 1)])])]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.downloadFile(_vm.selectFile)
            }
          }
        }, on), [_c('v-icon', [_vm._v("download")])], 1)]
      }
    }], null, false, 3001047841)
  }, [_vm._v(" "), _c('span', [_vm._v("Herunterladen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showRenameFile = true
            }
          }
        }, on), [_c('v-icon', [_vm._v("edit")])], 1)]
      }
    }], null, false, 255971008)
  }, [_vm._v(" "), _c('span', [_vm._v("Umbenennen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showDeleteFile = true) && (_vm.deleteFileData = _vm.selectFile)
            }
          }
        }, on), [_c('v-icon', [_vm._v("delete")])], 1)]
      }
    }], null, false, 1467067888)
  }, [_vm._v(" "), _c('span', [_vm._v("Löschen")])])], 1), _vm._v(" "), (_vm.showDownloadLog) ? _c('v-card-actions', [_c('v-card', {
    attrs: {
      "outlined": "",
      "width": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "ma-0 py-0"
  }, [_vm._v("\n              Download-Log\n              "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showDownloadLog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": ""
    }
  }, [_c('tbody', _vm._l((_vm.selectFile.downloadLog), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(_vm.$filters.date(item.date, "DD.M.YY hh:mm")) + " Uhr")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.contact, _vm.bbrbbr)))])])
  }), 0)])], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "30%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showNeuesVerzeichnis),
      callback: function($$v) {
        _vm.showNeuesVerzeichnis = $$v
      },
      expression: "showNeuesVerzeichnis"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_vm._v("Neues Verzeichnis erstellen")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Bezeichnung"
    },
    model: {
      value: (_vm.neu.name),
      callback: function($$v) {
        _vm.$set(_vm.neu, "name", $$v)
      },
      expression: "neu.name"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showNeuesVerzeichnis = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.createVerzeichnis()
      }
    }
  }, [_vm._v("Erstellen")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "30%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showNeuerOrdner),
      callback: function($$v) {
        _vm.showNeuerOrdner = $$v
      },
      expression: "showNeuerOrdner"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_vm._v("Neuer Ordner erstellen")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Bezeichnung"
    },
    model: {
      value: (_vm.neu.name),
      callback: function($$v) {
        _vm.$set(_vm.neu, "name", $$v)
      },
      expression: "neu.name"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showNeuerOrdner = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.createOrdner()
      }
    }
  }, [_vm._v("Erstellen")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "40%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showUploadFiles),
      callback: function($$v) {
        _vm.showUploadFiles = $$v
      },
      expression: "showUploadFiles"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_vm._v("Dateien hochladen")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [(!_vm.neu.uploadStatus) ? _c('v-file-input', {
    attrs: {
      "chips": "",
      "outlined": "",
      "counter": "",
      "multiple": "",
      "show-size": "",
      "label": "Dateien zum hochladen auswählen"
    },
    model: {
      value: (_vm.neu.dateien),
      callback: function($$v) {
        _vm.$set(_vm.neu, "dateien", $$v)
      },
      expression: "neu.dateien"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.uploadValue))]), _vm._v(" "), (_vm.neu.uploadStatus) ? _c('span', _vm._l((_vm.neu.uploadStatus), function(item, index) {
    return _c('span', {
      key: index
    }, [_c('v-progress-linear', {
      attrs: {
        "color": item === 100 ? 'green' : 'blue',
        "value": item,
        "height": "32",
        "rounded": ""
      }
    }, [_vm._v(_vm._s(_vm.neu.dateien[index].name) + " (" + _vm._s(item.toFixed(0)) + " %)")]), _vm._v(" "), (item < 100) ? _c('v-progress-linear', {
      staticClass: "mt-n1 pb-2",
      attrs: {
        "color": "blue",
        "height": "4",
        "indeterminate": "",
        "rounded": ""
      }
    }) : _vm._e()], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('v-alert', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v(_vm._s(_vm.info))]) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        (_vm.showUploadFiles = false) && (_vm.loading = false)
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "loading": _vm.loading,
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.uploadFiles()
      }
    }
  }, [_vm._v("Dateien hochladen")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "40%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showRenameFile),
      callback: function($$v) {
        _vm.showRenameFile = $$v
      },
      expression: "showRenameFile"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_vm._v("Datei Umbenennen")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "label": "Bezeichnung"
    },
    model: {
      value: (_vm.selectFile.name),
      callback: function($$v) {
        _vm.$set(_vm.selectFile, "name", $$v)
      },
      expression: "selectFile.name"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showRenameFile = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.renameFile()
      }
    }
  }, [_vm._v("Umbenennen")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "40%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showDeleteFile),
      callback: function($$v) {
        _vm.showDeleteFile = $$v
      },
      expression: "showDeleteFile"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', {
    staticClass: "tertiary white--text"
  }, [_vm._v("Datei löschen")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [_vm._v("\n        Willst du den Ordner "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.deleteFileData.name))]), _vm._v(" wirklich löschen? Alle\n        Unterordener und darin enthaltene Dateien werden unwiederuflich gelöscht. "), _c('br'), _c('br'), _vm._v("Folgende Ordner und\n        Dateien werden gelöscht:\n        "), _vm._l((_vm.deleteFileDataAll), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "mr-1 font-weight-bold"
    }, [_vm._v(_vm._s(item.name)), (index < _vm.deleteFileDataAll.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        (_vm.showDeleteFile = false) && (_vm.loading = false)
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    staticClass: "tertiary",
    attrs: {
      "loading": _vm.loading,
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteFiles()
      }
    }
  }, [_vm._v("Löschen")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86f6d84c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/dateien.vue
// module id = 798
// module chunks = 15